module.exports = __webpack_public_path__ + "img/right-info-close02.98b527bf.png";